// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-alerts {
  position: fixed;
  top: 82px;
  right: 24px;
  z-index: 2050;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: min(380px, calc(100vw - 32px));
  pointer-events: none;
}

.floating-alert {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-gap: 12px;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 14px 14px 16px;
  border: 1px solid;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 10px 25px rgba(44, 47, 72, 0.18);
  color: #47404f;
  pointer-events: auto;
  animation: floating-alert-in 180ms ease-out;
}

.floating-alert__icon {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  flex-shrink: 0;
}

.floating-alert__title {
  margin: 0 0 3px;
  color: #323332;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.25;
}

.floating-alert__message {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  word-break: break-word;
}

.floating-alert__close {
  border: 0;
  background: transparent;
  color: #797979;
  line-height: 1;
  padding: 2px;
  cursor: pointer;
}

.floating-alert__close:hover,
.floating-alert__close:focus {
  color: #303030;
}

.floating-alert__close .icon {
  width: 16px;
  height: 16px;
}

.floating-alert--success {
  background-color: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.floating-alert--success .floating-alert__title,
.floating-alert--success .floating-alert__icon {
  color: #155724;
}

.floating-alert--danger {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.floating-alert--danger .floating-alert__title,
.floating-alert--danger .floating-alert__icon {
  color: #721c24;
}

.floating-alert--warning {
  background-color: #fff3cd;
  border-color: #ffeeba;
  color: #856404;
}

.floating-alert--warning .floating-alert__title,
.floating-alert--warning .floating-alert__icon {
  color: #856404;
}

.floating-alert--info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}

.floating-alert--info .floating-alert__title,
.floating-alert--info .floating-alert__icon {
  color: #0c5460;
}

@keyframes floating-alert-in {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media only screen and (max-width: 767px) {
  .floating-alerts {
    top: 74px;
    right: 12px;
    left: 12px;
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Common/FloatingAlerts.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,cAAS;EAAT,SAAS;EACT,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,cAAc;EACd,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;EACb;AACF","sourcesContent":[".floating-alerts {\n  position: fixed;\n  top: 82px;\n  right: 24px;\n  z-index: 2050;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: min(380px, calc(100vw - 32px));\n  pointer-events: none;\n}\n\n.floating-alert {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 14px 14px 14px 16px;\n  border: 1px solid;\n  border-radius: 4px;\n  background: #fff;\n  box-shadow: 0 10px 25px rgba(44, 47, 72, 0.18);\n  color: #47404f;\n  pointer-events: auto;\n  animation: floating-alert-in 180ms ease-out;\n}\n\n.floating-alert__icon {\n  width: 18px;\n  height: 18px;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.floating-alert__title {\n  margin: 0 0 3px;\n  color: #323332;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.floating-alert__message {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n.floating-alert__close {\n  border: 0;\n  background: transparent;\n  color: #797979;\n  line-height: 1;\n  padding: 2px;\n  cursor: pointer;\n}\n\n.floating-alert__close:hover,\n.floating-alert__close:focus {\n  color: #303030;\n}\n\n.floating-alert__close .icon {\n  width: 16px;\n  height: 16px;\n}\n\n.floating-alert--success {\n  background-color: #d4edda;\n  border-color: #c3e6cb;\n  color: #155724;\n}\n\n.floating-alert--success .floating-alert__title,\n.floating-alert--success .floating-alert__icon {\n  color: #155724;\n}\n\n.floating-alert--danger {\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n  color: #721c24;\n}\n\n.floating-alert--danger .floating-alert__title,\n.floating-alert--danger .floating-alert__icon {\n  color: #721c24;\n}\n\n.floating-alert--warning {\n  background-color: #fff3cd;\n  border-color: #ffeeba;\n  color: #856404;\n}\n\n.floating-alert--warning .floating-alert__title,\n.floating-alert--warning .floating-alert__icon {\n  color: #856404;\n}\n\n.floating-alert--info {\n  background-color: #d1ecf1;\n  border-color: #bee5eb;\n  color: #0c5460;\n}\n\n.floating-alert--info .floating-alert__title,\n.floating-alert--info .floating-alert__icon {\n  color: #0c5460;\n}\n\n@keyframes floating-alert-in {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .floating-alerts {\n    top: 74px;\n    right: 12px;\n    left: 12px;\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
